import { Category } from '@smg-real-estate/hg-rets-schema';

export const objectTypeMappings: { [index: string]: Category[] } = {
  AGRI_AGRICULTURAL_INSTALLATION: [Category.Farm, Category.AgriculturalInstallation],
  AGRI_MOUNTAIN_FARM: [Category.Farm, Category.MountainFarm],
  AGRI_FARM: [Category.Farm],
  APPT_APARTMENT: [Category.Apartment, Category.Flat],
  APPT_DUPLEX: [Category.Apartment, Category.Duplex],
  APPT_ATTIC_FLAT: [Category.Apartment, Category.AtticFlat],
  APPT_ROOF_FLAT: [Category.Apartment, Category.RoofFlat],
  APPT_STUDIO: [Category.Apartment, Category.Studio],
  APPT_SINGLE_ROOM: [Category.Apartment, Category.SingleRoom],
  APPT_FURNISHED_DWELLING: [Category.Apartment, Category.FurnishedFlat],
  // todo: clarify if this makes sense
  APPT_FURNISHED_FLAT: [Category.Apartment, Category.FurnishedFlat],
  APPT_TERRACE_FLAT: [Category.Apartment, Category.TerraceFlat],
  APPT_BACHELOR_FLAT: [Category.Apartment, Category.BachelorFlat],
  APPT_LOFT: [Category.Apartment, Category.Loft],
  APPT_ATTIC: [Category.Apartment, Category.Attic],
  APPT_FLATSHARE: [Category.Apartment, Category.SharedApartment],
  GARDEN_ALLOTTMENT_GARDEN: [Category.AlottmentGarden],
  GASTRO_HOTEL: [Category.Hotel],
  GASTRO_RESTAURANT: [Category.CafeBar, Category.Restaurant],
  GASTRO_COFFEEHOUSE: [Category.CafeBar, Category.Coffeehouse],
  GASTRO_BAR: [Category.CafeBar, Category.Bar],
  GASTRO_CLUB_DISCO: [Category.CafeBar, Category.ClubDisco],
  GASTRO_CASINO: [Category.CafeBar, Category.Casino],
  GASTRO_MOVIE_THEATER: [Category.CafeBar, Category.MovieTheater],
  GASTRO_SQUASH_BADMINTON: [Category.SquashBadminton],
  GASTRO_INDOOR_TENNIS_COURTS: [Category.IndoorTennisCourt],
  GASTRO_TENNIS_COURT: [Category.TennisCourt],
  GASTRO_SPORTS_HALL: [Category.SportsHall],
  GASTRO_CAMPGROUND_TENT_CAMPING: [Category.Campground],
  GASTRO_OUTDOOR_SWIMMING_POOL: [Category.OutdoorSwimmingPool],
  GASTRO_INDOOR_SWIMMINGPOOL: [Category.IndoorSwimmingPool],
  GASTRO_GOLF_COURSE: [Category.GolfCourse],
  GASTRO_MOTEL: [Category.Motel, Category.BedAndBreakfast],
  GASTRO_PUB: [Category.CafeBar, Category.Pub],
  HOUSE_SINGLE_HOUSE: [Category.House, Category.SingleHouse],
  HOUSE_ROW_HOUSE: [Category.House, Category.RowHouse],
  HOUSE_BIFAMILIAR_HOUSE: [Category.House, Category.BifamiliarHouse],
  HOUSE_TERRACE_HOUSE: [Category.House, Category.TerraceHouse],
  HOUSE_VILLA: [Category.House, Category.Villa],
  HOUSE_FARM_HOUSE: [Category.House, Category.FarmHouse],
  HOUSE_MULTIPLE_DWELLING: [Category.House, Category.MultipleDwelling],
  HOUSE_CAVE_HOUSE_EARTHEN_HOUSE: [Category.House, Category.CaveHouse],
  HOUSE_CASTLE: [Category.House, Category.Castle],
  HOUSE_GRANNY_FLAT: [Category.Flat, Category.GrannyFlat],
  HOUSE_CHALET: [Category.House, Category.Chalet],
  HOUSE_RUSTIC_HOUSE: [Category.House, Category.RusticHouse],
  INDUS_OFFICE: [Category.Office],
  INDUS_SHOP: [Category.Retail, Category.Shop],
  INDUS_ADVERTISING_AREA: [Category.Retail, Category.AdvertisingArea],
  INDUS_COMMERCIAL: [Category.Retail, Category.Commercial],
  INDUS_STORAGE_ROOM: [Category.Retail, Category.StorageRoom],
  INDUS_PRACTICE: [Category.Retail, Category.Practice],
  INDUS_KIOSK: [Category.Retail, Category.Kiosk],
  INDUS_GARDENING: [Category.Retail, Category.Gardening],
  INDUS_FUEL_STATION: [Category.Retail, Category.FuelStation],
  INDUS_GARAGE: [Category.Retail, Category.Garage],
  INDUS_CHEESE_FACTORY: [Category.Retail, Category.CheeseFactory],
  INDUS_BUTCHER: [Category.Retail, Category.Butcher],
  INDUS_BAKERY: [Category.Retail, Category.Bakery],
  INDUS_HAIRDRESSER: [Category.Retail, Category.Hairdresser],
  INDUS_SHOPPING_CENTRE: [Category.Retail, Category.ShoppingCentre],
  INDUS_FACTORY: [Category.Factory],
  INDUS_INDUSTRIAL_OBJECT: [Category.Factory, Category.IndustrialObject],
  INDUS_ARCADE: [Category.RetailSpace, Category.Arcade],
  INDUS_ATELIER: [Category.RetailSpace, Category.Atelier],
  INDUS_LIVING_COMMERCIAL_BUILDING: [Category.ResidentialCommercialBuilding],
  // todo: clarify if this makes sense
  INDUS_RESIDENTIAL_COMMERCIAL_BUILDING: [Category.ResidentialCommercialBuilding],
  INDUS_LIBRARY: [Category.RetailSpace, Category.Library],
  INDUS_HOSPITAL: [Category.Hospital],
  INDUS_LABORATORY: [Category.Office, Category.Laboratory],
  INDUS_MINI_GOLF_COURSE: [Category.MiniGolfCourse],
  INDUS_NURSING_HOME: [Category.NursingHome],
  INDUS_RIDING_HALL: [Category.RidingHall],
  INDUS_SANATORIUM: [Category.Sanatorium],
  INDUS_WORKSHOP: [Category.Workshop],
  INDUS_PARTY_ROOM: [Category.CafeBar, Category.PartyRoom],
  INDUS_SAUNA: [Category.Sauna],
  INDUS_SOLARIUM: [Category.Solarium],
  INDUS_CARPENTRY_SHOP: [Category.Factory, Category.CarpentryShop],
  INDUS_OLD_AGE_HOME: [Category.OldAgeHome],
  INDUS_DEPARTMENT_STORE: [Category.Retail, Category.DepartmentStore],
  INDUS_HOME: [Category.Institution],
  INDUS_DISPLAY_WINDOW: [Category.DisplayWindow],
  INDUS_PARKING_GARAGE: [Category.ParkingSpace],
  // todo: clarify if this makes sense
  INDUS_PARKING_SPACE: [Category.ParkingSpace],
  INDUS_PARKING_SURFACE: [Category.CarPark],
  PARK_OPEN_SLOT: [Category.OpenSlot],
  PARK_COVERED_SLOT: [Category.CoveredSlot],
  PARK_SINGLE_GARAGE: [Category.SingleGarage],
  PARK_DOUBLE_GARAGE: [Category.DoubleGarage],
  PARK_UNDERGROUND_SLOT: [Category.UndergroundSlot],
  PARK_BOAT_DRY_DOCK: [Category.BoatDryDock],
  PARK_BOAT_LANDING_STAGE: [Category.BoatLandingStage],
  PARK_COVERED_PARKING_PLACE_BIKE: [Category.Garage, Category.CoveredParkingPlaceBike],
  PARK_OUTDOOR_PARKING_PLACE_BIKE: [Category.Garage, Category.OutdoorParkingPlaceBike],
  PARK_HORSE_BOX: [Category.HorseBox],
  PARK_BOAT_MOORING: [Category.BoatMooring],
  PROP_BUILDING_LAND: [Category.Plot, Category.BuildingLand],
  PROP_AGRICULTURAL_LAND: [Category.AgriculturalLand],
  PROP_COMMERCIAL_LAND: [Category.Plot, Category.CommercialLand],
  PROP_INDUSTRIAL_LAND: [Category.Plot, Category.IndustrialLand],
  SECONDARY_HOBBY_ROOM: [Category.HobbyRoom],
  SECONDARY_CELLAR_COMPARTMENT: [Category.CellarCompartment],
  SECONDARY_ATTIC_COMPARTMENT: [Category.AtticCompartment],
};
